// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"transitionVairant_paragraph__3aX5N","highlight":"transitionVairant_highlight__wbdvm","btn":"transitionVairant_btn__2Cgkr"};